// @flow
import * as React from 'react';
import Impressions from 'app/packages/impression-logging';
import StopEventPropagation from 'app/packages/stop-event-propagation/StopEventPropagation';
import { Layer, Modal as GestaltModal } from 'gestalt';

type Props = {|
  ...React.ElementConfig<typeof GestaltModal>,
  allowClickAndDrag?: boolean,
  allowScroll?: boolean,
|};

export const MODAL_ZINDEX = 1000;

class Modal extends React.Component<Props> {
  componentDidMount() {
    // End active impressions when a Modal is opened
    this.pauseImpressionsTracking();
  }

  componentWillUnmount() {
    this.resumeImpressionsTracking();
  }

  pauseImpressionsTracking = () => {
    Impressions.pause();
  };

  resumeImpressionsTracking = () => {
    Impressions.resume();
  };

  handleDismiss = () => {
    // Restart visible impressions when a Modal is closed
    this.resumeImpressionsTracking();
    this.props.onDismiss();
  };

  render() {
    const {
      accessibilityCloseLabel,
      accessibilityModalLabel,
      allowClickAndDrag,
      allowScroll,
      children,
      footer,
      heading,
      role,
      size,
    } = this.props;

    return (
      <Layer>
        <StopEventPropagation allowClickAndDrag={allowClickAndDrag} allowScroll={allowScroll}>
          {/* TODO: Remove zIndex from header and other places so only Layer is needed */}
          <div style={{ position: 'absolute', zIndex: MODAL_ZINDEX }}>
            <GestaltModal
              accessibilityCloseLabel={accessibilityCloseLabel}
              accessibilityModalLabel={accessibilityModalLabel}
              heading={heading}
              footer={footer}
              onDismiss={this.handleDismiss}
              role={role}
              size={size}
            >
              {children}
            </GestaltModal>
          </div>
        </StopEventPropagation>
      </Layer>
    );
  }
}

export default Modal;
